var _rect, _path, _path2, _rect2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoldAndAccept(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.152344,
    width: 47.564,
    height: 40.7904,
    rx: 20.3952,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H18V28H22V12Z",
    stroke: "#2EDC35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12H26V28H30V12Z",
    stroke: "#2EDC35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5884,
    y: 27.2432,
    width: 49.564,
    height: 42.3409,
    rx: 21.1704,
    fill: "#2EDC35",
    stroke: "#374249",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.2773,
    y: 34.4087,
    width: 28.1861,
    height: 28.1861,
    rx: 14.093,
    fill: "#2EDC35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_250_242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.9858,
    y: 48.6392,
    width: 28.8441,
    height: 28.8441,
    rx: 14.4221,
    transform: "rotate(135 67.9858 48.6392)",
    fill: "#2EDC35"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_250_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1801 53.5224L58.1801 56.5666C58.1813 56.8493 58.124 57.129 58.0121 57.3879C57.9001 57.6469 57.7359 57.8793 57.5299 58.0704C57.324 58.2614 57.0808 58.4069 56.8161 58.4974C56.5513 58.5879 56.2707 58.6216 55.9924 58.5961C52.9043 58.2568 49.9379 57.1898 47.3316 55.4809C44.9069 53.9229 42.8511 51.8442 41.3103 49.3924C39.6142 46.7451 38.5587 43.7311 38.2293 40.5946C38.2043 40.314 38.2372 40.0311 38.3262 39.7641C38.4151 39.4971 38.5581 39.2517 38.7459 39.0437C38.9338 38.8356 39.1625 38.6693 39.4173 38.5555C39.6722 38.4416 39.9478 38.3827 40.2264 38.3824L43.2371 38.3824C43.7241 38.3776 44.1963 38.552 44.5656 38.8731C44.9349 39.1942 45.1761 39.6401 45.2442 40.1278C45.3713 41.102 45.607 42.0586 45.9467 42.9792C46.0818 43.3424 46.111 43.7371 46.0309 44.1166C45.9509 44.4961 45.7649 44.8444 45.4951 45.1203L44.2206 46.4091C45.6492 48.9495 47.7295 51.053 50.242 52.4975L51.5165 51.2088C51.7894 50.936 52.1338 50.7479 52.5091 50.667C52.8844 50.5861 53.2748 50.6156 53.634 50.7522C54.5445 51.0957 55.4905 51.334 56.454 51.4625C56.9415 51.532 57.3867 51.7803 57.705 52.1601C58.0233 52.5399 58.1924 53.0248 58.1801 53.5224Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_242"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.2773,
    y: 34.4087,
    width: 28.1861,
    height: 28.1861,
    rx: 14.093,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_250_242"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.9858,
    y: 48.6392,
    width: 28.8441,
    height: 28.8441,
    rx: 14.4221,
    transform: "rotate(135 67.9858 48.6392)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_250_242"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.7676,
    y: 34.0762,
    width: 28.2432,
    height: 28.5579,
    rx: 14.1216,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldAndAccept);
export default __webpack_public_path__ + "static/media/holdAndAccept.cab53eba7210f012b6dc3792322872b9.svg";
export { ForwardRef as ReactComponent };